import _createForOfIteratorHelper from "/Users/tauseeq/PycharmProjects/jsonvisualizer/my-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _createClass from "/Users/tauseeq/PycharmProjects/jsonvisualizer/my-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/Users/tauseeq/PycharmProjects/jsonvisualizer/my-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/Users/tauseeq/PycharmProjects/jsonvisualizer/my-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/Users/tauseeq/PycharmProjects/jsonvisualizer/my-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import { EditorView } from '@codemirror/view';
import { StateEffect, MapMode, StateField, EditorSelection, CharCategory } from '@codemirror/state';
import { RangeValue, RangeSet } from '@codemirror/rangeset';
import { codePointSize, codePointAt, fromCodePoint } from '@codemirror/text';
import { syntaxTree } from '@codemirror/language';
var defaults = {
  brackets: ["(", "[", "{", "'", '"'],
  before: ")]}'\":;>"
};
var closeBracketEffect = /*@__PURE__*/StateEffect.define({
  map: function map(value, mapping) {
    var mapped = mapping.mapPos(value, -1, MapMode.TrackAfter);
    return mapped == null ? undefined : mapped;
  }
});
var skipBracketEffect = /*@__PURE__*/StateEffect.define({
  map: function map(value, mapping) {
    return mapping.mapPos(value);
  }
});
var closedBracket = /*@__PURE__*/new ( /*#__PURE__*/function (_RangeValue) {
  _inherits(_class, _RangeValue);

  var _super = _createSuper(_class);

  function _class() {
    _classCallCheck(this, _class);

    return _super.apply(this, arguments);
  }

  return _createClass(_class);
}(RangeValue))();
closedBracket.startSide = 1;
closedBracket.endSide = -1;
var bracketState = /*@__PURE__*/StateField.define({
  create: function create() {
    return RangeSet.empty;
  },
  update: function update(value, tr) {
    if (tr.selection) {
      var lineStart = tr.state.doc.lineAt(tr.selection.main.head).from;
      var prevLineStart = tr.startState.doc.lineAt(tr.startState.selection.main.head).from;
      if (lineStart != tr.changes.mapPos(prevLineStart, -1)) value = RangeSet.empty;
    }

    value = value.map(tr.changes);

    var _iterator = _createForOfIteratorHelper(tr.effects),
        _step;

    try {
      var _loop = function _loop() {
        var effect = _step.value;
        if (effect.is(closeBracketEffect)) value = value.update({
          add: [closedBracket.range(effect.value, effect.value + 1)]
        });else if (effect.is(skipBracketEffect)) value = value.update({
          filter: function filter(from) {
            return from != effect.value;
          }
        });
      };

      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return value;
  }
});
/**
Extension to enable bracket-closing behavior. When a closeable
bracket is typed, its closing bracket is immediately inserted
after the cursor. When closing a bracket directly in front of a
closing bracket inserted by the extension, the cursor moves over
that bracket.
*/

function closeBrackets() {
  return [EditorView.inputHandler.of(handleInput), bracketState];
}

var definedClosing = "()[]{}<>";

function closing(ch) {
  for (var i = 0; i < definedClosing.length; i += 2) {
    if (definedClosing.charCodeAt(i) == ch) return definedClosing.charAt(i + 1);
  }

  return fromCodePoint(ch < 128 ? ch : ch + 1);
}

function config(state, pos) {
  return state.languageDataAt("closeBrackets", pos)[0] || defaults;
}

function handleInput(view, from, to, insert) {
  if (view.composing) return false;
  var sel = view.state.selection.main;
  if (insert.length > 2 || insert.length == 2 && codePointSize(codePointAt(insert, 0)) == 1 || from != sel.from || to != sel.to) return false;
  var tr = insertBracket(view.state, insert);
  if (!tr) return false;
  view.dispatch(tr);
  return true;
}
/**
Command that implements deleting a pair of matching brackets when
the cursor is between them.
*/


var deleteBracketPair = function deleteBracketPair(_ref) {
  var state = _ref.state,
      dispatch = _ref.dispatch;
  var conf = config(state, state.selection.main.head);
  var tokens = conf.brackets || defaults.brackets;
  var dont = null,
      changes = state.changeByRange(function (range) {
    if (range.empty) {
      var before = prevChar(state.doc, range.head);

      var _iterator2 = _createForOfIteratorHelper(tokens),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var token = _step2.value;
          if (token == before && nextChar(state.doc, range.head) == closing(codePointAt(token, 0))) return {
            changes: {
              from: range.head - token.length,
              to: range.head + token.length
            },
            range: EditorSelection.cursor(range.head - token.length),
            userEvent: "delete.backward"
          };
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }

    return {
      range: dont = range
    };
  });
  if (!dont) dispatch(state.update(changes, {
    scrollIntoView: true
  }));
  return !dont;
};
/**
Close-brackets related key bindings. Binds Backspace to
[`deleteBracketPair`](https://codemirror.net/6/docs/ref/#closebrackets.deleteBracketPair).
*/


var closeBracketsKeymap = [{
  key: "Backspace",
  run: deleteBracketPair
}];
/**
Implements the extension's behavior on text insertion. If the
given string counts as a bracket in the language around the
selection, and replacing the selection with it requires custom
behavior (inserting a closing version or skipping past a
previously-closed bracket), this function returns a transaction
representing that custom behavior. (You only need this if you want
to programmatically insert brackets—the
[`closeBrackets`](https://codemirror.net/6/docs/ref/#closebrackets.closeBrackets) extension will
take care of running this for user input.)
*/

function insertBracket(state, bracket) {
  var conf = config(state, state.selection.main.head);
  var tokens = conf.brackets || defaults.brackets;

  var _iterator3 = _createForOfIteratorHelper(tokens),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var tok = _step3.value;
      var closed = closing(codePointAt(tok, 0));
      if (bracket == tok) return closed == tok ? handleSame(state, tok, tokens.indexOf(tok + tok + tok) > -1) : handleOpen(state, tok, closed, conf.before || defaults.before);
      if (bracket == closed && closedBracketAt(state, state.selection.main.from)) return handleClose(state, tok, closed);
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  return null;
}

function closedBracketAt(state, pos) {
  var found = false;
  state.field(bracketState).between(0, state.doc.length, function (from) {
    if (from == pos) found = true;
  });
  return found;
}

function nextChar(doc, pos) {
  var next = doc.sliceString(pos, pos + 2);
  return next.slice(0, codePointSize(codePointAt(next, 0)));
}

function prevChar(doc, pos) {
  var prev = doc.sliceString(pos - 2, pos);
  return codePointSize(codePointAt(prev, 0)) == prev.length ? prev : prev.slice(1);
}

function handleOpen(state, open, close, closeBefore) {
  var dont = null,
      changes = state.changeByRange(function (range) {
    if (!range.empty) return {
      changes: [{
        insert: open,
        from: range.from
      }, {
        insert: close,
        from: range.to
      }],
      effects: closeBracketEffect.of(range.to + open.length),
      range: EditorSelection.range(range.anchor + open.length, range.head + open.length)
    };
    var next = nextChar(state.doc, range.head);
    if (!next || /\s/.test(next) || closeBefore.indexOf(next) > -1) return {
      changes: {
        insert: open + close,
        from: range.head
      },
      effects: closeBracketEffect.of(range.head + open.length),
      range: EditorSelection.cursor(range.head + open.length)
    };
    return {
      range: dont = range
    };
  });
  return dont ? null : state.update(changes, {
    scrollIntoView: true,
    userEvent: "input.type"
  });
}

function handleClose(state, _open, close) {
  var dont = null,
      moved = state.selection.ranges.map(function (range) {
    if (range.empty && nextChar(state.doc, range.head) == close) return EditorSelection.cursor(range.head + close.length);
    return dont = range;
  });
  return dont ? null : state.update({
    selection: EditorSelection.create(moved, state.selection.mainIndex),
    scrollIntoView: true,
    effects: state.selection.ranges.map(function (_ref2) {
      var from = _ref2.from;
      return skipBracketEffect.of(from);
    })
  });
} // Handles cases where the open and close token are the same, and
// possibly triple quotes (as in `"""abc"""`-style quoting).


function handleSame(state, token, allowTriple) {
  var dont = null,
      changes = state.changeByRange(function (range) {
    if (!range.empty) return {
      changes: [{
        insert: token,
        from: range.from
      }, {
        insert: token,
        from: range.to
      }],
      effects: closeBracketEffect.of(range.to + token.length),
      range: EditorSelection.range(range.anchor + token.length, range.head + token.length)
    };
    var pos = range.head,
        next = nextChar(state.doc, pos);

    if (next == token) {
      if (nodeStart(state, pos)) {
        return {
          changes: {
            insert: token + token,
            from: pos
          },
          effects: closeBracketEffect.of(pos + token.length),
          range: EditorSelection.cursor(pos + token.length)
        };
      } else if (closedBracketAt(state, pos)) {
        var isTriple = allowTriple && state.sliceDoc(pos, pos + token.length * 3) == token + token + token;
        return {
          range: EditorSelection.cursor(pos + token.length * (isTriple ? 3 : 1)),
          effects: skipBracketEffect.of(pos)
        };
      }
    } else if (allowTriple && state.sliceDoc(pos - 2 * token.length, pos) == token + token && nodeStart(state, pos - 2 * token.length)) {
      return {
        changes: {
          insert: token + token + token + token,
          from: pos
        },
        effects: closeBracketEffect.of(pos + token.length),
        range: EditorSelection.cursor(pos + token.length)
      };
    } else if (state.charCategorizer(pos)(next) != CharCategory.Word) {
      var prev = state.sliceDoc(pos - 1, pos);
      if (prev != token && state.charCategorizer(pos)(prev) != CharCategory.Word) return {
        changes: {
          insert: token + token,
          from: pos
        },
        effects: closeBracketEffect.of(pos + token.length),
        range: EditorSelection.cursor(pos + token.length)
      };
    }

    return {
      range: dont = range
    };
  });
  return dont ? null : state.update(changes, {
    scrollIntoView: true,
    userEvent: "input.type"
  });
}

function nodeStart(state, pos) {
  var tree = syntaxTree(state).resolveInner(pos + 1);
  return tree.parent && tree.from == pos;
}

export { closeBrackets, closeBracketsKeymap, deleteBracketPair, insertBracket };